import { FC } from 'react';
import { CheckIcon } from '@chakra-ui/icons';
import { Spinner } from '@chakra-ui/react';
import { FileProcessStatus } from '../../graphql/generated';
import { StatusLabel } from './status-label';

type GenericFileProcessStatusProps = {
  status: FileProcessStatus;
};

export const GenericFileProcessStatus: FC<GenericFileProcessStatusProps> = ({
  status,
}) => {
  switch (status) {
    case FileProcessStatus.PROCESSING:
      return (
        <StatusLabel label="Processing" data-testid="processing-status">
          <Spinner color="blue.500" size="sm" />
        </StatusLabel>
      );
    case FileProcessStatus.DONE:
      return (
        <StatusLabel label="Done" data-testid="done-status">
          <CheckIcon color="green.500" />
        </StatusLabel>
      );
    default:
      return null;
  }
};
